import gql from 'graphql-tag'

const reviewFragment = gql`
  fragment review on Review {
    id
    title
    comment
    rating
    isVerified
    updatedAt
  }
`

export default reviewFragment
